// extracted by mini-css-extract-plugin
module.exports = {"scollTable":"ScrollTable_scollTable__24IL9"};